module.exports = __webpack_public_path__ + "assets/overlay-front-teeth.822b05ba905017d2d46908b6ecdd0ec0.png";